<template>
  <FullScreenLayoutContent>
    <template #header>
      <div class="flex justify-end p-4">
        <BaseTextButton color="text" trailing-icon="arrow_right_alt" @click="skipOnboarding">{{
          $t('common.skip')
        }}</BaseTextButton>
      </div>
    </template>
    <div class="flex grow flex-col justify-center p-4 lg:p-0">
      <h3 class="text-headline-medium lg:text-display-medium text-gray-700">
        Willkommen bei Menon! 👋
      </h3>
      <p class="text-body-large lg:text-headline-small mt-8">
        Wir wollen nicht mit Schwächen, Defiziten oder Problemen beginnen. Wir starten bei deinen
        Stärken.
      </p>
      <p class="text-body-large lg:text-headline-small mt-1">
        Finde jetzt heraus, welche deine persönliche Superkraft ist.
      </p>
      <p class="text-body-medium lg:text-body-large text-on-surface-variant mt-4">
        Dauer: ~5 Minuten
      </p>
      <div class="mt-16 flex gap-4">
        <LoadingWrapper :state="status">
          <BaseTextButton
            color="filled"
            @click="handleSuperpowerSurvey(data.feedbackTopicId)"
            size="M"
            >Superkraft herausfinden</BaseTextButton
          >
        </LoadingWrapper>
        <BaseTextButton color="tonal" @click="skipOnboarding" size="M"
          >Erstmal umschauen</BaseTextButton
        >
      </div>
    </div>
  </FullScreenLayoutContent>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import FullScreenLayoutContent from '../../../core/components/layouts/FullScreenLayoutContent.vue'
  import { useMemeberSettings } from '../../../core/composables/use-member-settings'
  import { ApiRequestStatus } from '../../../core/models/api/api-request-status'
  import { useSnackStore } from '../../../stores/snack.store'
  import { useStartSelfFeedback } from '@/modules/start-self-feedback/use-start-self-feedback'
  import { useOnboarding } from '../../../core/composables/use-onboarding'
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { onBeforeMount } from 'vue'
  import { useUserStore } from '../../../stores/user.store'

  const router = useRouter()
  const { user } = useUserStore()
  const { showError } = useSnackStore()
  const { updateMemberSettings, updateStatus } = useMemeberSettings()
  const { data, status } = useOnboarding()
  const { selfFeedbackFormData, startSelfFeedback, clearForm } = useStartSelfFeedback()

  onBeforeMount(() => {
    if (user.settings.onboardingCompleted) {
      router.replace({ name: 'dashboard' })
    }
  })

  const skipOnboarding = async () => {
    await updateMemberSettings({
      onboardingCompleted: true,
    })

    if (updateStatus.value == ApiRequestStatus.Success) {
      router.push({ name: 'dashboard' })
    } else {
      showError('Fehler beim Überspringen des Onboardings')
    }
  }

  const handleSuperpowerSurvey = async (feedbackTopicId: string) => {
    await updateMemberSettings({
      onboardingCompleted: true,
    })

    if (updateStatus.value == ApiRequestStatus.Success) {
      selfFeedbackFormData.templateIds = [feedbackTopicId]
      await startSelfFeedback()
      clearForm()
    } else {
      showError('Ups, da ist etwas schief gelaufen')
    }
  }
</script>
